import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FolderInput } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { NativeSelect } from "../common";

export const PROJECT_FOLDERS = [
  { value: "chat", label: "Saved from chat" },
  { value: "brief", label: "Client brief & attachments" },
  { value: "moodboard", label: "Moodboards & concepts" },
  { value: "layout", label: "Layouts" },
  { value: "drawing", label: "Working drawings" },
  { value: "artwork", label: "Final artwork" },
];

export function SaveToProjectDialog({ msg, projects, defaultProject, onClose }) {
  const [pid, setPid] = useState("");
  const [cat, setCat] = useState("chat");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (msg) { setPid(defaultProject || ""); setCat("chat"); } }, [msg, defaultProject]);
  const save = async () => {
    setBusy(true);
    try {
      await api.post(`/files/${msg.attachment.id}/save-to-project`, { project_id: pid, category: cat });
      toast.success(`Saved to ${projects.find((p) => p.id === pid)?.name} · ${PROJECT_FOLDERS.find((f) => f.value === cat).label}`);
      onClose();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <Dialog open={!!msg} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="save-to-project-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FolderInput className="h-4 w-4 text-[#15966B]" />Save to project files</DialogTitle>
          <DialogDescription className="truncate">{msg?.attachment?.name}</DialogDescription>
        </DialogHeader>
        <label className="space-y-1.5 text-xs font-medium text-slate-600"><span>Project</span>
          <NativeSelect className="w-full" testid="save-to-project-project" value={pid} onChange={setPid} placeholder="Select project…" options={projects.map((p) => ({ value: p.id, label: p.name }))} /></label>
        <label className="space-y-1.5 text-xs font-medium text-slate-600"><span>Folder</span>
          <NativeSelect className="w-full" testid="save-to-project-folder" value={cat} onChange={setCat} options={PROJECT_FOLDERS} /></label>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" data-testid="save-to-project-cancel" onClick={onClose}>Cancel</Button>
          <Button data-testid="save-to-project-submit" disabled={!pid || busy} onClick={save}>{busy ? "Saving…" : "Save"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
